import React from "react";

export const defaultModalContext = {
  show: false,
  action: null,
  actionText: null,
  actionProps: null,
  toggleHandle: () => false,
  showHandle: () => false,
  closeHandle: () => false,
};

const ModalContext = React.createContext(defaultModalContext);

export default ModalContext;
